const NavbarButton2 = () => {
  return (
    <div className="navbarbutton">
      <a href="./sheetmusic">Sheetmusic</a>
    </div>
  );
};

export default NavbarButton2;
